import api from '@/utils/axios';
import { unwrapList } from '@/utils/apiHelpers';
import type { RegisterReference } from '@/shared/types/users.types';

export async function fetchRegisterReference(): Promise<RegisterReference> {
    const res = await api.get('/register/reference');
    const data = res.data.data ?? res.data;

    return {
        types: unwrapList(data.types),
        zones: unwrapList(data.zones),
        vehicle_types: unwrapList(data.vehicle_types),
        specializations: unwrapList(data.specializations),
        availability_slots: unwrapList(data.availability_slots),
        categories: unwrapList(data.categories),
    };
}
